<div class="component-login-user" *ngIf="!smallView">
  <h3>Favorites - <span class="smaller-text">Please <a href="{{loginURL}}"><strong>log in</strong></a> to set your favorites.</span></h3>
</div>

<div class="component-login-user component-login-user--compact" *ngIf="smallView">
  <p *ngIf="!userName"><a href="{{loginURL}}" class="helper-simple-link"><strong>Log In</strong></a></p>
  <p class="component-login-user--compact-loged-in-user" *ngIf="userName">Welcome, <strong
    class="component-login-user--compact-loged-in-user-username">{{userName}}</strong>. Want to <a href="#" (click)="logOutUser($event)"> <strong>log
    out</strong></a>?</p>
</div>

